// Meta Pixel helper — Pixel ID: 2964287970431808
// Provides typed wrappers around fbq() for PageView, AddToCart, InitiateCheckout.

const PIXEL_ID = '2964287970431808'
const CURRENCY = 'ARS'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

let initialized = false

/**
 * Loads the Meta Pixel script and fires the initial PageView.
 * Safe to call multiple times — runs only once.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (initialized) return
  initialized = true

  try {
    const f: any = window
    if (!f.fbq) {
      const n: any = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
      }
      f.fbq = n
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      // Append script to <head> directly. The original Meta snippet inserts
      // before the first <script> tag, which can be undefined in SPAs /
      // sandboxed iframes — that was the source of the parentNode crash.
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      const target = document.head || document.body || document.documentElement
      target.appendChild(script)
    }

    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
  } catch (err) {
    // Never let analytics break the app
    console.warn('[MetaPixel] init failed:', err)
  }
}

/**
 * Tracks AddToCart — fired when the user selects the order bump.
 */
export function trackAddToCart(params: {
  content_name: string
  value: number
}): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', {
    content_name: params.content_name,
    content_type: 'product',
    currency: CURRENCY,
    value: params.value,
  })
}

/**
 * Tracks InitiateCheckout — fired when the user clicks the main buy button
 * or accepts the exit-intent upsell.
 */
export function trackInitiateCheckout(params: {
  content_name: string
  value: number
  num_items?: number
}): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'InitiateCheckout', {
    content_name: params.content_name,
    currency: CURRENCY,
    value: params.value,
    num_items: params.num_items ?? 1,
  })
}
